import { BaseClient } from '@/api'

export class CardDynamicClient extends BaseClient {
  constructor(
  ) {
    super('card-dynamics')
  }
}
